import { render, staticRenderFns } from "./rolePermModal.vue?vue&type=template&id=4a9826b2&scoped=true&"
import script from "./rolePermModal.vue?vue&type=script&lang=js&"
export * from "./rolePermModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9826b2",
  null
  
)

export default component.exports